<template>
  <div class="main">
    <van-nav-bar title="公示详情" left-arrow @click-left="onClickLeft" />

    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <div class="container">
        <div class="top">
          <p class="title">{{ currentData.gsmc }}</p>
          <div class="btn">
            <div class="voteBottom">
              <div class="VoteType">{{ currentData.gslx | message }}</div>
            </div>
          </div>
        </div>
        <div class="content">
          <img
            class="images"
            width="77px"
            height="88px"
            src="../../assets/img/img_gongshi.png"
          />
          <div class="vote-time">公示描述:</div>

          <p class="content-title">
            {{ currentData.gsms }}
          </p>

          <p class="vote-time">设备设施类型：</p>
          <p class="title-info">{{ currentData.sssblx }}</p>
          <!-- <p style="font-size: 14px"></p> -->

          <p class="vote-time">施工日期:</p>
          <div class="voteName">
            <img
              style="vertical-align: middle"
              src="../../assets/img/ico_time_begin.png"
              alt=""
            />
            <div class="name" style="vertical-align: middle; line-height: 21px">
              {{ currentData.sgkssj || currentData.yjsgsj }}
            </div>
            <img
              style="vertical-align: middle"
              src="../../assets/img/ico_time_over.png"
              alt=""
            />
            <div class="name" style="vertical-align: middle; line-height: 21px">
              {{ currentData.sgjssj || currentData.yjsgyssj }}
            </div>
          </div>

          <p class="vote-time">设备单位：</p>
          <p class="title-info">{{ currentData.sjdwmc }}</p>
          <p class="vote-time">验收结论：</p>
          <p class="title-info">{{ currentData.ysqk || "暂无" }}</p>

          <p class="vote-time" v-if="currentData.gslx == 0">验收时间：</p>
          <p class="title-info" v-if="currentData.gslx == 0">
            {{ currentData.yjsgyssj }}
          </p>
          <p class="vote-time">公示时间：</p>
          <div class="voteName">
            <img
              style="vertical-align: middle"
              src="../../assets/img/ico_time_begin.png"
              alt=""
            />
            <div class="name" style="vertical-align: middle; line-height: 21px">
              {{ currentData.gsfqsj }}
            </div>
            <img
              style="vertical-align: middle"
              src="../../assets/img/ico_time_over.png"
              alt=""
            />
            <div class="name" style="vertical-align: middle; line-height: 21px">
              {{ currentData.gsjssj }}
            </div>
          </div>

          <p class="vote-time">附件：</p>
          <div v-if="currentData.fjurlList.length > 0">
            <div v-if="currentData.gslx != 0">
              <div class="example">
                <img
                  v-for="(item, index) in oneList"
                  :key="index"
                  class="one"
                  :src="item.url"
                  alt=""
                />
              </div>
              <div class="example">
                <img
                  v-for="(item, index) in twoList"
                  :key="index"
                  class="one"
                  :src="item.url"
                  alt=""
                />
              </div>
            </div>
            <div v-else-if="currentData.gslx == 0">
              <div
                class="upload"
                v-for="(item, index) in currentData.fjurlList"
                :key="index"
              >
                <div class="upload-item" @click="download(item)">
                  <img
                    class="item-left"
                    src="../../assets/img/ico_file.png"
                    alt=""
                  />
                  <div class="item-middle">
                    <p class="upload-text">{{ item.name }}</p>
                    <span class="upload-file">{{ item.size }}</span>
                  </div>
                  <img
                    class="item-right"
                    src="../../assets//img//ico_download_big.png"
                    alt=""
                    @click="download(item)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-else class="title-info">暂无</div>

          <p class="vote-time">投票情况：</p>
          <div class="vote-info">
            <div class="info-top">
              <span class="vote-house"
                >涉及房屋总数：{{ currentData.fwlb.length }}户</span
              >
              <span class="vote-num"
                >弃票人数:{{ currentData.qprs || 0 }}人</span
              >
            </div>
            <div class="info-agree">
              <div class="agree-icon"></div>
              <p class="icon-text">
                同意人数：{{ currentData.tptyrs }}人（{{
                  currentData.tyrszb
                }}%）
              </p>
              <p class="icon-text">
                房屋面积占比：{{ currentData.tptyrs }}人（{{
                  currentData.tyfwmjzb
                }}%）
              </p>
              <div class="agree-icon" style="background: #ff6c1a"></div>
              <p class="icon-text">
                反对人数：{{ currentData.tpfdrs }}人（{{
                  currentData.fdrszb
                }}%）
              </p>
              <p class="icon-text">
                房屋面积占比：{{ currentData.tpfdrs }}人（{{
                  currentData.fdfwmjzb
                }}%）
              </p>
              <div class="agree-icon" style="background: #a38076"></div>
              <p class="icon-text">
                弃票人数：{{ currentData.qprs }}人（{{ currentData.qprszb }}%）
              </p>
              <p class="icon-text">
                房屋面积占比：{{ currentData.qprs }}人（{{
                  currentData.qpfwmjzb
                }}%）
              </p>

              <div class="scale-tip">
                <div
                  class="first"
                  :style="{
                    width: currentData.tyrszbpy,
                  }"
                ></div>
                <div
                  class="secone"
                  :style="{
                    width: currentData.fdrszbpy,
                  }"
                >
                  <div class="circle"></div>
                </div>
                <div
                  class="third"
                  :style="{
                    width: currentData.qprszbpy,
                  }"
                >
                  <div class="circle"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- <p class="vote-time">涉及房屋列表：</p>
          <table
            style="width: 100%; border-collapse: collapse"
            border-collapse="collapse"
          >
            <tr>
              <th>楼幢单元室号</th>
              <th>房屋面积</th>
              <th>分摊金额</th>
            </tr>
            <tr v-for="(item, index) in currentData.fwlb" :key="index">
              <td>{{ item.fwmc }}</td>
              <td>{{ item.fwmj }}<span style="font-size: 10px">m²</span></td>
              <td>{{ item.ftje }}<span style="font-size: 10px">元</span></td>
            </tr>
          </table> -->
        </div>
      </div>
    </van-pull-refresh>
    <div v-if="pdfView" style="height: calc(100% - 46px)">
      <pdfPage :pdfSrc="pdfUrl"></pdfPage>
    </div>
  </div>
</template>

<script>
import pdfPage from "./pdfNoPage.vue";
import api from "@/api/public.js";
import { json } from "body-parser";
export default {
  name: "",
  components: {
    pdfPage,
  },
  data() {
    return {
      pdfView: false,

      show: true,
      loading: false,
      pdfUrl: "",
      currentData: {
        fjurlList: [],
      },
      oneList: [],
      twoList: [],
      status: "1", // 1已投票  0 未投票
    };
  },
  filters: {
    message(val) {
      // if (val == '1' || val == '2') {
      //   return '使用投票'
      // } else if (val == '3') {
      //   return "投票公示"
      // } else {
      //   return '验收公示'
      // }
      if (val == 0) {
        return "使用公示";
      } else if (val == 1) {
        return "投票公示";
      } else {
        return "验收公示";
      }
    },
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    init() {
      this.loading = true;
      api
        .getDetail(this.$route.query.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.loading = false;

            this.currentData = {
              ...res.data.data,
            };
            if (this.currentData.fjurlList.length > 0) {
              this.currentData.fjurlList.forEach((item) => {
                item.url = item.url.replace(
                  "http://172.17.20.11:9000",
                  "http://222.214.193.17:9000"
                );
              });
            }
            if (this.currentData.gslx != 0) {
              if (
                res.data.data.fjurlList &&
                res.data.data.fjurlList.length > 3
              ) {
                this.oneList = res.data.data.fjurlList.slice(0, 3);
                this.twoList = res.data.data.fjurlList.slice(
                  3,
                  res.data.data.fjurlList.length
                );
              } else {
                this.oneList = res.data.data.fjurlList;
              }
            }
            // 占比图偏移
            this.currentData.tyrszbpy = this.currentData.tyrszb + "%";
            this.currentData.fdrszbpy = this.currentData.fdrszb + "%";
            this.currentData.qprszbpy = this.currentData.qprszb + "%";
            this.currentData.fwlb = res.data.data.fwlb || [];
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onRefresh() {
      this.init();
    },
    yulan(item) {
      this.pdfUrl = item.url;
      this.pdfView = true;
      // this.$router.push({
      //     path: "/preview",
      //     query: { pdfUrl: item.url},
      //   });
    },
    download(file) {
      console.log(file.url);
      api
        .minioDownload({ url: file.url })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/octet-stream",
          });
          // var blob = new Blob([res], { type: "application/octet-stream" });
          if ("msSaveOrOpenBlob" in navigator) {
            // IE导出
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          }
          // navigator.msSaveBlob(blob, file.name);//本地保存
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = window.URL.createObjectURL(blob);
          link.download = file.name; //下载的文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.$toast("下载失败，请稍后重试！");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.van-nav-bar {
  position: sticky;
  top: 0;
  z-index: 999;
}

.main {
  background: linear-gradient(
    180deg,
    rgba(255, 216, 193, 0.42) 0%,
    rgba(255, 216, 193, 0) 100%
  );

  .container {
    width: 100%;
    padding: 20px;

    // padding-bottom: 20px;
    .top {
      width: 100%;
      min-height: 140px;
      overflow: hidden;
      position: relative;

      .title {
        position: relative;
        z-index: 9;
        width: 100%;
        min-height: 30px;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222120;
        line-height: 30px;
        margin: 0;
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }

      .btn {
        margin-top: 10px;

        .join {
          width: 120px;
          height: 30px;
          background: #f7f7f7;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid #e9e9e9;
          font-size: 13px;
        }

        .vote {
          width: 80px;
          height: 30px;
          font-size: 13px;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid #00c797;
        }
      }

      .images {
        position: absolute;
        z-index: 1;
        top: 45px;
        right: 0px;
        width: 120px;
        height: 110px;
        // background: #f4f7f9;
        // box-shadow: inset 2px 2px 6px 0px rgba(255, 255, 255, 0.6);
        opacity: 1;
      }
    }

    .content {
      position: relative;
      width: 100%;
      height: 100%;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      padding: 16px;

      .images {
        position: absolute;
        top: -94px;
        right: 0px;
        width: 120px;
        height: 110px;
        // background: #f4f7f9;
        // box-shadow: inset 2px 2px 6px 0px rgba(255, 255, 255, 0.6);
        opacity: 1;
      }

      .title-info {
        font-size: 14px;
        color: #4e4d4d;
        font-weight: 500;
        // height: 30px;
        // line-height: 30px;
        margin: 0;
      }
    }
  }
}

.voteBottom {
  //   padding: 0 16px;
  margin: 15px 0;

  button {
    padding: 0 17px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #ff6c1a;
    color: #fff;
    border-radius: 30px;
    float: right;
    border: none;
    font-size: 13px;
  }

  .voteIn,
  .VoteType {
    display: inline-block;
    font-size: 13px;
    line-height: 30px;
    padding: 0 5px;
    border-radius: 3px;
  }

  .voteIn {
    background: #f7f7f7;
    color: #6b6a6a;
    border: 1px solid #e9e9e9;
    letter-spacing: 1px;

    img {
      // margin-top: 5px;
      margin-top: 6px;
      margin-right: 5px;
      float: left;
      width: 16px;
      height: 16px;
    }
  }

  .VoteType {
    color: #00c797;
    background: rgba(0, 199, 151, 0.05);
    border: 1px solid #00c797;
    margin-left: 5px;
  }
}

.voteName {
  margin-top: 16px;
  padding: 0 16px;
  display: flex;

  img {
    display: block;
    width: 22px;
    height: 22px;
  }

  .name {
    // flex: 1;

    width: 85px;
    height: 20px;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    margin-left: 5px;
    color: #4e4d4d;
    line-height: 16px;
    overflow: hidden;
    margin-right: 10px;
  }
}

.content-title {
  width: 100%;
  min-height: 30px;
  word-break: break-all;
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #4e4d4d;
  line-height: 30px;
}

.vote-time {
  font-size: 16px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #4e4d4d;
  line-height: 19px;
}

.upload {
  min-height: 62px;

  .upload-item {
    display: flex;
    width: 100%;
    height: 52px;
    // justify-content: center;
    border: 1px solid #eee;
    padding: 0 18px;
    margin-bottom: 10px;

    .item-left {
      width: 24px;
      height: 29px;
      margin-top: 12px;
    }

    .item-middle {
      flex: 1;
      height: 30px;
      margin-top: 8px;
      margin-left: 10px;

      .upload-text {
        font-size: 14px;
        margin: 0;
        font-weight: 500;
        color: #4e4d4d;
      }

      .upload-file {
        font-size: 12px;
        font-weight: 500;
      }
    }

    .item-right {
      margin-top: 12px;
      width: 20px;
      height: 20px;
    }
  }
}

.example {
  display: flex;

  .one {
    width: 31.5%;
    height: 96px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    margin-right: 10px;
  }
}

table {
  border-collapse: collapse;
  margin: 0 auto;
  text-align: center;
}

table th {
  background-color: #f4f4f5;
  font-size: 14px;
  color: #999998;
  font-weight: 500;
}

table thead th {
  background-color: #cce8eb;
  width: 100px;
  border-bottom: 1px solid #eee;
}

table tr {
  height: 50px;
  color: #4e4d4d;

  border-bottom: 1px solid #eee;
}

table tr:nth-child(odd) {
  background: #fff;
}

table tr:nth-child(even) {
  background: #fff;
}

.scale-tip {
  box-sizing: border-box;
  display: flex;
  height: 16px;
  width: 100%;
  margin-top: 10px;
}

.first {
  background-color: #00c797;
  border-radius: 10px;
}

.secone {
  position: relative;
  background-color: #ff6c1a;
  border-radius: 10px;
}

.circle {
  position: absolute;
  top: 0;
  width: 7px;
  height: 16px;
  border-radius: 0 50px 50px 0;
  background-color: #fff;
}

.third {
  position: relative;
  border-radius: 10px;
  background-color: #a38076;
}

.vote-info {
  width: 100%;
  min-height: 282px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #e9e9e9;
  padding: 10px;
  margin-top: 20px;

  .info-top {
    position: relative;
    height: 30px;

    .vote-house {
      font-size: 15px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #4e4d4d;
      line-height: 30px;
      margin: 0;
    }

    .vote-num {
      position: absolute;
      right: 10px;
      font-size: 12px;
      color: #999998;
      line-height: 30px;
    }
  }

  .agree-icon {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 16px;
    height: 16px;
    background: #00c797;
    border: 2px solid #ffffff;
    border-radius: 20px;
  }

  .icon-text {
    width: 100%;
    height: 26px;
    font-size: 14px;
    font-weight: 500;
    color: #4e4d4d;
    line-height: 26px;
    margin: 0px;
  }

  .van-progress {
    margin-top: 20px;
    height: 16px;
    border-radius: 8px 8px 8px 8px;
    background: #ff6c1a;

    border: 2px solid #ffffff;

    /deep/.van-progress__portion {
      top: -2px;
      background: #00c797 !important;
      height: 16px;
      border-radius: 8px 8px 8px 8px;
      border: 2px solid #ffffff;
    }
  }
}
</style>
